angular.module('rjmNg.directives').directive "clientSettings", [
  "timezoneService",
  "currencyService",
  "Clients"
  "$routeParams"
  "$anchorScroll"
  "notification"
  "app"
  "$location"
  "$clientAppUrl"
  "$q"
  "FEATURE_TIER"
  "logger"
  (
    timezoneService
    currencyService
    Clients
    $routeParams
    $anchorScroll
    notification
    app
    $location
    $clientAppUrl
    $q
    FEATURE_TIER
    logger
  ) ->
    restrict: "E"
    templateUrl: "directive.clientSettings.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$clientAppUrl"
      (
        $clientAppUrl
      ) ->

        view = @
        view.isEssentialsClient = false

        logger.log('Client Settings Usage', 'Open', 1, 'edit')

        init = ->
          if !app.isAdminUser()
            $location.path $clientAppUrl("/")

          view.loading = true
          view.client = null
          view.clientId = $routeParams.clientId
          $anchorScroll()

          view.options = 
            perform_updates: [ 
              value: "0"
              text: "No"
            ,
              value: "1"
              text: "Yes" 
            ]
            week_start_day: [
              value: "1"
              text: "Monday"
            ,
              value: "7"
              text: "Sunday"
            ],
            stale_email_summary_action: [ 
              value: "0"
              text: "No"
            ,
              value: "1"
              text: "Yes" 
            ]

          $q.all([timezoneService.fetch(),
            currencyService.fetch(),
            Clients.get(view.clientId),
          ]).then ([timezones, currencies, clientInfo]) ->
            view.options.timezones = timezones.data
            view.options.currencies = currencies.data
            view.client = clientInfo
            view.isEssentialsClient = view.client.properties.feature_tier is FEATURE_TIER.BASIC.toString()
            {
              perform_updates,
              timezone,
              default_currency,
              week_start_day,
              blackout_hours,
              forced_update_hours,
              stale_email_summary_action,
            } = view.client.properties

            angular.extend view.client.properties,
              perform_updates: perform_updates or "0"
              timezone: timezone or "America/New_York"
              default_currency: default_currency or "USD"
              week_start_day: week_start_day or "1"
              blackout_hours: blackout_hours or ""
              forced_update_hours: forced_update_hours or ""
              stale_email_summary_action: stale_email_summary_action or "1"
            view.loading = false


        notificationMessages =
          success: "Your settings were successfully saved."
          error: "We were unable to save your settings. Please try again."


        view.savePreferences = ->
          notification.clear('client-settings')
          view.loading = true
          Clients.save(view.client)
            .then (response) ->
              view.loading = false
              $anchorScroll()
              notification.success(null, notificationMessages.success, "client-settings", { dismissable: true, bindHtml: true })
              logger.log('Client Settings Usage', 'Save', 1, 'edit')
            .catch (error) ->
              view.loading = false
              $anchorScroll()
              notification.error(null, notificationMessages.error, "client-settings", { dismissable: true, bindHtml: true })

        @$onInit = ->
          init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "clientSettings", scope.view.loading
]
